import { Button } from '@fluentui/react-components';
import React, { useState } from 'react';
import { EditRegular } from '@fluentui/react-icons';
import { UPDATE_MILESTONE_CATEGORY } from '../../../../utils/statApi/MilestoneTemplateApi';
import { IMilestoneCategory } from '../../../../utils/types/IProcessTemplate';
import MilestoneCategoriesAddEditPanel from './MilestoneCategoriesAddEditPanel';
import { iconButtonStyles } from '../../../../app/common/styles/CommonStyleObjects';

interface IMilestoneCategoriesEditButtonProps {
  item: IMilestoneCategory;
}

const MilestoneCategoriesEditButton = (props: IMilestoneCategoriesEditButtonProps): JSX.Element => {
  const { item } = props;

  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const togglePanel = (): void => {
    setIsPanelOpen(!isPanelOpen);
  };

  const editMutation = UPDATE_MILESTONE_CATEGORY;

  return (
    <>
      <Button
        appearance="transparent"
        icon={<EditRegular color={iconButtonStyles.color} />}
        onClick={togglePanel}
      >
        Edit Category
      </Button>
      {isPanelOpen && (
        <MilestoneCategoriesAddEditPanel
          closePanel={togglePanel}
          mutation={editMutation}
          category={item}
        />
      )}
    </>
  );
};

export default MilestoneCategoriesEditButton;
